import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/tiptap/styles.css';

import ReactDOM from 'react-dom/client';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import {PersistGate} from 'redux-persist/integration/react';
import {MantineProvider} from '@mantine/core';
import {Notifications} from '@mantine/notifications';
import App from './App';
import {store, persistor} from './store';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter>
                <MantineProvider>
                    <Notifications />
                    <App />
                </MantineProvider>
            </BrowserRouter>
        </PersistGate>
    </Provider>
);
